import { useState } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';

export interface AdditionalInformationItem {
  label: string;
  component: React.ReactElement;
}

export default function AdditionalInformationList({ items }: Readonly<{ items: AdditionalInformationItem[] }>) {
  const [expandedItemIds, setExpandedItemIds] = useState<string[]>(items.length > 0 ? [items[0].label] : []);

  return (
    <AccordionPrimitive.Root
      type="multiple"
      value={expandedItemIds}
      onValueChange={setExpandedItemIds}
      className="w-full"
    >
      {items.map(item => (
        <AccordionPrimitive.Item key={item.label} value={item.label} className="border-b">
          <AccordionPrimitive.Header asChild>
            <AccordionPrimitive.Trigger asChild>
              <button type="button"
                className="flex w-full items-center justify-between gap-2 px-4 py-2 text-left text-lg font-bold text-primary hover:text-primary-dark desktop:px-0 [&[data-state=open]>svg]:rotate-180"
                data-testid={`additional-info-${item.label}`}
              >
                <h2>{item.label}</h2>
                <ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200" />
              </button>
            </AccordionPrimitive.Trigger>
          </AccordionPrimitive.Header>

          <AccordionPrimitive.Content className="text-base mx-4 desktop:mx-0">
            {item.component}
          </AccordionPrimitive.Content>
        </AccordionPrimitive.Item>
      ))}
    </AccordionPrimitive.Root>
  );
}
